import type { FirstLoginDestination, LoginMethod } from '@today/types'
import { apiClient } from './api.client'

/** `POST /t/{slug}/invitation/begin` — the tenant's first-login path (TO-309). */
export interface FirstLoginStart {
	method: LoginMethod
	/** The hosted-UI `identity_provider`: `COGNITO` or the tenant's SAML provider. */
	identityProvider: string
	email: string
}

export interface FirstLoginResult {
	destination: FirstLoginDestination
}

const invitationPath = (slug: string, step: 'begin' | 'accept' | 'complete') =>
	`/t/${encodeURIComponent(slug)}/invitation/${step}`

/**
 * Client for the invitation first-login surface (TO-309). The link token and
 * the chosen password travel only in request bodies — never in a URL.
 */
export const invitationService = {
	begin: async (slug: string, token: string): Promise<FirstLoginStart> =>
		(await apiClient.post<FirstLoginStart>(invitationPath(slug, 'begin'), { token })).data,

	accept: async (slug: string, token: string, newPassword: string): Promise<FirstLoginResult> =>
		(await apiClient.post<FirstLoginResult>(invitationPath(slug, 'accept'), { token, newPassword })).data,

	complete: async (slug: string, token: string): Promise<FirstLoginResult> =>
		(await apiClient.post<FirstLoginResult>(invitationPath(slug, 'complete'), { token })).data,
}
